import React from 'react';
import { useWebMCP } from 'usewebmcp';
import { executeCheckContrast } from './executors/checkContrast';
import { CHECK_CONTRAST_INPUT_SCHEMA } from './schemas/inputSchemas';

export const CheckContrastTool: React.FC = () => {
  useWebMCP({
    name: 'check_contrast',
    description:
      'Calculate contrast between two colors and check WCAG 2.1 and APCA accessibility levels using the Leonardo contrast engine. Use when someone asks whether a color pair is accessible or meets contrast requirements.',
    inputSchema: CHECK_CONTRAST_INPUT_SCHEMA,
    annotations: { readOnlyHint: true },
    execute: executeCheckContrast,
  });

  return null;
};
